export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            有想看的片子或想说的话，随时联系夜猫团队
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="group cursor-pointer">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-50 group-hover:bg-primary-100 transition-colors">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿建议</h3>
                <p className="text-xs text-foreground-500">hello@nightowlcinema.fun</p>
              </div>

              <div className="group cursor-pointer">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-50 group-hover:bg-accent-100 transition-colors">
                  <i className="ri-discuss-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">片源合作</h3>
                <p className="text-xs text-foreground-500">partner@nightowlcinema.fun</p>
              </div>

              <div className="group cursor-pointer">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100 group-hover:bg-secondary-200 transition-colors">
                  <i className="ri-question-answer-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线反馈</h3>
                <p className="text-xs text-foreground-500">工作日 24h 内回复</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/70">
              <p className="text-xs text-foreground-400 text-center leading-relaxed">
                夜猫电影院持续更新片库中，如果你有想看的电影或电视剧，欢迎通过以上方式告诉我们。我们会在 24 小时内处理你的投稿和建议，让午夜观影体验越来越好。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}